module.exports = __webpack_public_path__ + "static/crater-app-create-22d7c46b951dc2a5d5c0dd1f835a1643.jpg";